<template>
<!-- 更新情報入力画面 -->
<CCard>
  <CCardHeader>
    <h2>クライアント更新</h2>
  </CCardHeader>
  <CCardBody>
    <p><span class="asterisk">*</span>が付いている項目は必須入力項目です</p>
    <ValidationObserver ref="obs" v-slot="ObserverProps">
      <CRow v-if="message.length">
        <ul>
          <li style="color: red;" v-for="error in message" :key="error">{{ error }}</li>
        </ul>
      </CRow>
     <CRow>
       <CCol sm="3">
          <ValidationProvider name='取引先企業名' rules="required|max:100" v-slot="ProviderProps">
            <label>取引先企業名<span class="asterisk">*</span></label>
            <CInput v-model="company_name" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='取引先担当者名' rules="max:60" v-slot="ProviderProps">
            <CInput label="取引先担当者名" v-model="staff_name" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='電話番号' rules="tel" v-slot="ProviderProps">
            <CInput label="電話番号" v-model="telephone" description="ハイフンなしで入力してください" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="6">
          <ValidationProvider name='住所' rules="max:60" v-slot="ProviderProps">
            <CInput label="住所" v-model="address"/>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='E-Mail' rules="email" v-slot="ProviderProps">
            <CInput label="E-Mail" v-model="email" placeholder="email@example.com"/>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='支払いサイト' rules="numeric|max:3" v-slot="ProviderProps">
            <CInput label="支払いサイト" v-model="usance" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="6">
          <ValidationProvider name='備考' rules="max:254" v-slot="ProviderProps">
            <CInput label="備考" v-model="remarks" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <br>
      <CRow class="mt-3 align-items-center">
        <!-- 左寄せ：戻る -->
        <CCol class="text-start">
          <button class="btn btn-secondary" @click="valueCheck">戻る</button>
        </CCol>
        <CCol class="text-center">
          <button v-on:click="openModal" class="btn btn-info" :disabled="ObserverProps.invalid">確認</button>
          <!-- 更新確認モーダルコンポーネント呼出 -->
          <ClientUpdateModal 
            :draggable="true" 
            :resizable="true" 
            :company_name="company_name" 
            :staff_name="staff_name" 
            :telephone="telephone" 
            :address="address" 
            :email="email" 
            :usance="usance" 
            :remarks="remarks" 
            :loading="loading"
            v-show="showModal" 
            @update="update" 
            @close="closeModal">
          </ClientUpdateModal>
          </CCol>
          <!-- 空白スペース用 -->
        <CCol ></CCol>
      </CRow>
    </ValidationObserver>
  </CCardBody>
</CCard>
</template>

<script>
import ConstList from './../ConstList'
import ClientUpdateModal from './ClientUpdateModal'
import axios from 'axios'
export default {
  name: 'ClientUpdate',
  components: {
    ClientUpdateModal
  },
  data() {
    return {
      showModal: false,
      company_name: '',
      staff_name:'',
      telephone: '',
      address: '',
      email: '',
      usance:'',
      remarks: '',
      items: [],
      message: [],
      company_check: [],
      loading: false,
    }
  },
  methods: {
    // プロジェクト詳細へ遷移する際の入力値チェック
    valueCheck: function () {
      if ((this.company_name) || (this.staff_name) || (this.telephone) || (this.address) || (this.email) || (this.usance) || (this.remarks)) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_CLIENT_INFO,
            params: {
              value: this.$route.params.value
            }
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_CLIENT_INFO,
          params: {
            value: this.$route.params.value
          }
        })
      }
    },
    // モーダルを表示
    openModal: function () {
      // モーダル表示（toggle）
      this.showModal = true
    },
    // 更新情報を送信
    update: function () {
      this.loading = true;
      // JSON形式パラメータ設定
      const params = {
        id : this.$route.params.value.id,
        company_name : this.company_name,
        staff_name : this.staff_name,
        telephone : this.telephone,
        address : this.address,
        email : this.email,
        usance : this.usance,
        remarks : this.remarks
      }
      axios
        .post((process.env.VUE_APP_API_ORIGIN) + '/client/update', params,  
          { headers: {
             // content-type指定。@requestBodyでサーバ側にてバインドするため。
             'Content-Type': 'application/json' 
          }},)
        .then(() => {
          alert(ConstList.REGISTER_MESSAGE)
          this.showModal = false
          // プロジェクト管理画面へ遷移する
          this.$router.push({
            name: ConstList.ROUTE_CLIENT_LIST
          })
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false
    }
  },

  // DBから各種情報を取得
  mounted: function () {
    this.company_name = this.$route.params.value.company_name
    this.staff_name = this.$route.params.value.staff_name
    this.telephone = this.$route.params.value.telephone
    this.address = this.$route.params.value.address
    this.email = this.$route.params.value.email
    this.usance = this.$route.params.value.usance
    this.remarks = this.$route.params.value.remarks
    this.check = this.$route.params.value
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

</style>
